<template>
  <div class="appcontainer">
    <div class="flow-detail">
      <div class="flow-menu" v-if="readerOnly===false">
        <template v-for="item in menueList">
          <div class="menu-item"  draggable="true" @dragstart="drag(item)" :key="item.type" v-if="item.isShow">
            <i :class="item.icon"></i>
            <span >{{item.name}}</span>
          </div>
        </template>
      </div>
      <div id="flowContent"
           ref="flowContent"
           @drop="drop($event)"
           :style="`top:${flowContent.top}px;left:${flowContent.left}px;transform: scale(${flowContent.zoomSize});transform-origin:${flowContent.transformOriginX}px ${flowContent.transformOriginY}px;`"
           @mouseup.prevent.self="mouseUp"
           @mousewheel.prevent.self="zoomSize"
           @mousedown.prevent.self="mousedown($event,'flowContent')"
           @dragover="allowDrop($event)"
           >
        <flowNode v-for="node in data.nodeList" :key="node[dataFormat.node.sourceId]"
                  :node="node"
                  :id="node[dataFormat.node.sourceId]"

                  :canvasMenuViasble.sync="canvasMenuViasble"
                  :editType.sync="editType"
                  :canvasMenuPositionObj.sync="canvasMenuPositionObj"
                  :parameterLine.sync="parameterLine"
                  
                  :node_standard_code.sync="node_standard_code"

                  @changeNodeSite="changeNodeSite"
                  >
        </flowNode>
      </div>
      <div id="minimap">
        <div id="miniview">
          <div ref="flowdesign_canvas" style="position:absolute;top:-400px;left:-560px;"></div>
        </div>
        <div id="selectWin" 
            @mouseup.prevent="mouseUp" 
            @mousedown.prevent="mousedown($event,'selectWin')"  
            ref="selectWin" 
            :style="`width:${selectWinOpt.width}px;height:${selectWinOpt.height}px;top:${selectWinOpt.top}px;left:${selectWinOpt.left}px;`"></div>
      </div>
    </div>
    <canvasMenu v-if="readerOnly===false" 
                :visable.sync="canvasMenuViasble"
                @deleteHandle="deleteHandle"  
                @editHandle="editHandle" />
  </div>
</template>

<script>
  import { jsPlumb } from 'jsplumb'
  import flowNode from './flowNode.vue'
  import canvasMenu from './canvasMenu.vue'
  import mixin from '../lib/mixin/index'
  export default {
    name: 'yzFlow',
    mixins: [mixin],
    provide () {
      return {
        flowMain: this
      }
    },
    data () {
      return {
        // canvasMenu 的位置
        parameterLine: {},
        canvasMenuPositionObj: {
          top: 100,
          left: 100
        },
        node_standard_code: null,
        canvasMenuViasble: false,
        jsPlumb: null, // jsPlumb 实例
        // 是否加载完毕
        loadEasyFlowFinish: false,
        data: {
          nodeList: this.nodeList,
          lineList: this.lineList
        },
        currentItem: '', // 临时存添加的元素
        timer: null, // 定时器,判断单双击,
        currentConnect: '', // 当前的连接线
        editType: '' // 编辑的类型
      }
    },
    components: {
      flowNode,
      canvasMenu
    },
    watch: {
      loadComplete: function (newVal, oldVal) {
        if (newVal) {
          this.jsPlumb = jsPlumb.getInstance()
          this.$nextTick(() => {
            this.init()
          })
        }
      },
      visableEditeLine: function (newVal, oldVal) {
        if (this.currentElement[this.dataFormat.line.name]) {
          if (newVal === false && oldVal === true) {
            this.currentConnect.getOverlay('label-1').setLabel(this.currentElement[this.dataFormat.line.name])
            this.copyFlow()
          }
        }
      },
      visableEditeNode: function (newVal, oldVal) {
        if (this.currentElement && this.currentElement[this.dataFormat.node.name]) {
          if (newVal === false && oldVal === true) {
            this.data.nodeList = this.data.nodeList.map(item => {
              if (item[this.dataFormat.node.sourceId] === this.currentElement[this.dataFormat.node.sourceId]) {
                item[this.dataFormat.node.name] = this.currentElement[this.dataFormat.node.name]
                if (item[this.dataFormat.node.nodetype] === 2) {
                  item[this.dataFormat.node.standard] = this.currentElement.nodeInfo[this.dataFormat.node.standard]
                }
              }
              return item
            })
            this.copyFlow()
          }
        }
      }
    },
    methods: {
      init () {
        const _this = this
        this.jsPlumb.ready(function () {
          // 导入默认配置
          _this.jsPlumb.importDefaults(_this.jsplumbSetting)
          // 会使整个jsPlumb立即重绘。
          _this.jsPlumb.setSuspendDrawing(false, true)
        // 初始化节点
          _this.loadEasyFlow()
          // 复制流程图
          _this.copyFlow()

          // 连线
          _this.jsPlumb.bind('connection', function (evt) {
            // eslint-disable-next-line camelcase
            let sourceId = evt.source.id
            // eslint-disable-next-line camelcase
            let targetId = evt.target.id
            if (_this.loadEasyFlowFinish) {
              _this.$emit('connectionLine', { [_this.dataFormat.node.sourceId]: sourceId, [_this.dataFormat.node.targetId]: targetId }, (data) => {
                if (data) {
                  _this.data.lineList.push(data)
                } else {
                  _this.unConnectLine(evt.connection)
                }
              })
            };
          })

          // 删除连线
          _this.jsPlumb.bind('connectionDetached', function (evt) {
            _this.deleteLine(evt.sourceId, evt.targetId)
          })

          //  右键 线
          _this.jsPlumb.bind('contextmenu', function (endpoint, originalEvent) {
            if (originalEvent.button === 2) {
              originalEvent.preventDefault()
              _this.canvasMenuViasble = true
              _this.canvasMenuPositionObj.left = originalEvent.pageX
              _this.canvasMenuPositionObj.top = originalEvent.pageY
              _this.parameterLine = endpoint
              _this.editType = 'line'
            }
          })

          // beforeDrop
          _this.jsPlumb.bind('beforeDrop', function (evt) {
            let from = evt.sourceId
            let to = evt.targetId
            if (from === to) {
              _this.$message.error('不能连接自己')
              return false
            } else if (_this.hasLine(from, to)) {
              _this.$message.error('不能重复连线')
              return false
            }
            return true
          })
          _this.jsPlumb.bind('beforeDetach', function (evt) {
            // console.log('beforeDetach', evt)
          })
        })
      },
      // 加载流程图
      loadEasyFlow () {
        // 初始化节点
        for (var i = 0; i < this.data.nodeList.length; i++) {
          let node = this.data.nodeList[i]
          // 设置源点，可以拖出线连接其他节点
          this.jsPlumb.makeSource(node[this.dataFormat.node.sourceId] + '', this.jsplumbSourceOptions)
          // 设置目标点，其他源点拖出的线可以连接该节点
          this.jsPlumb.makeTarget(node[this.dataFormat.node.sourceId] + '', this.jsplumbTargetOptions)
          this.jsPlumb.draggable(node[this.dataFormat.node.sourceId] + '', {
            containment: 'parent'
          })
        }

        // 初始化连线
        for (var j = 0; j < this.data.lineList.length; j++) {
          let line = this.data.lineList[j]
          let connection = this.jsPlumb.connect({
            source: line[this.dataFormat.node.sourceId] + '',
            target: line[this.dataFormat.node.targetId] + ''
          }, this.jsplumbConnectOptions)

          connection.getOverlay('label-1').setLabel(line[this.dataFormat.line.name]) // 初始化label
        }
        this.$nextTick(function () {
          this.loadEasyFlowFinish = true
        })
      },
      // 右菜单的编辑
      // eslint-disable-next-line camelcase
      editHandle (param, standard_code) {
        if (this.editType === 'line') {
          this.editLine(param)
          this.$emit('update:visableEditeLine', true)
          // this.visableEditeLine = true
        } else {
          // eslint-disable-next-line camelcase
          if (standard_code === 1002) {
            this.editNode(param[this.dataFormat.node.sourceId])
            this.$emit('update:visableAuto', true)
          } else {
            this.editNode(param[this.dataFormat.node.sourceId])
            this.$emit('update:visableEditeNode', true)
          }
        }
      },
      deleteHandle (param) {
        if (this.editType === 'line') {
          this.rightDelteLine(param)
        } else {
          this.deleteNode(param[this.dataFormat.node.sourceId])
        }
      },
      // 添加新的节点
      addNode (temp) {
        this.data.nodeList.push(temp)
        this.$nextTick(function () {
          this.jsPlumb.makeSource(temp[this.dataFormat.node.sourceId] + '', this.jsplumbSourceOptions)
          this.jsPlumb.makeTarget(temp[this.dataFormat.node.sourceId] + '', this.jsplumbTargetOptions)
          this.jsPlumb.draggable(temp[this.dataFormat.node.sourceId] + '', {
            containment: 'parent'
          })
          this.copyFlow()
        })
      },
      // 删除线
      deleteLine (from, to) {
        let _this = this
        this.data.lineList = this.data.lineList.filter(function (line) {
          return !(line[_this.dataFormat.node.sourceId] + '' === from && line[_this.dataFormat.node.targetId] + '' === to)
        })
      },
      unConnectLine (parameter) {
        this.data.lineList.find(item => item[this.dataFormat.node.sourceId] + '' === parameter.sourceId && item[this.dataFormat.node.targetId] + '' === parameter.targetId)
        this.jsPlumb.deleteConnection(parameter)
        this.copyFlow()
      },
      rightDelteLine (parameter) {
        let currenLine = this.data.lineList.find(item => item[this.dataFormat.node.sourceId] + '' === parameter.sourceId && item[this.dataFormat.node.targetId] + '' === parameter.targetId)
        this.$emit('delConnect', currenLine[this.dataFormat.line.lineId], (data) => {
          if (data) {
            this.jsPlumb.deleteConnection(parameter)
            this.copyFlow()
          }
        })
      },
      changeNodeSite (data) {
        for (var i = 0; i < this.data.nodeList.length; i++) {
          let node = this.data.nodeList[i]
          if (node[this.dataFormat.node.sourceId] === data.nodeId) {
            node[this.dataFormat.node.left] = data.left
            node[this.dataFormat.node.top] = data.top
            this.copyFlow()
            // 只读 不掉 接口
            if (!this.readerOnly) {
              this.$emit('changeNode', node)
            }
            break
          }
        }
      },
      deleteNode (nodeId) {
        let _this = this
        this.$emit('delNode', nodeId, (data) => {
          if (data) {
            try {
              _this.data.nodeList.forEach((item, index) => {
                if (item[_this.dataFormat.node.sourceId] === nodeId) {
                  _this.data.nodeList.splice(index, 1)
                }
              })
              _this.$nextTick(function () {
                _this.jsPlumb.removeAllEndpoints(nodeId + '')
                _this.copyFlow()
              })
            } catch (e) {
              console.log('err', e)
            }
          }
        })
      },
      editNode (nodeId) {
        this.$emit('update:currentElement', { node_id: nodeId, node_standard_code: this.node_standard_code })
        this.editType = 'node'
      },
      editLine (conn) {
        var _this = this
        _this.currentConnect = conn
        _this.data.lineList.forEach(function (item, index) {
          if (item[_this.dataFormat.node.sourceId] + '' === conn.sourceId && item[_this.dataFormat.node.targetId] + '' === conn.targetId) {
            _this.$emit('update:currentElement', item)
            _this.editType = 'line'
          }
        })
      },
      // 是否具有该线
      hasLine (from, to) {
        for (var i = 0; i < this.data.lineList.length; i++) {
          var line = this.data.lineList[i]
          if (line[this.dataFormat.node.sourceId] + '' === from && line[this.dataFormat.node.targetId] + '' === to) {
            return true
          }
        }
        return false
      },
      // 是否含有相反的线
      hashOppositeLine (from, to) {
        return this.hasLine(to, from)
      },
      drag (item) {
        this.currentItem = item
      },
      async drop (event) {
        let self = this
        let nodeInfo = {}
        nodeInfo[this.dataFormat.node.name] = this.currentItem.name
        nodeInfo[this.dataFormat.node.nodetype] = this.currentItem.nodetype
        nodeInfo[this.dataFormat.node.standard] = this.currentItem.standard

        nodeInfo[this.dataFormat.node.left] = event.offsetX - 75
        nodeInfo[this.dataFormat.node.top] = event.offsetY - 14
  
        self.$emit('addNode', nodeInfo, (data) => {
          if (data) {
            self.addNode(data)
          }
        })
      }
    }
  }
</script>
<style lang="less">
  @import url('../lib/less/index.less');
</style>



// WEBPACK FOOTER //
// packages/yz-flow/src/index.vue